import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { ArrowLeft } from 'lucide-react';

export default function TermsAndConditions() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[hsl(35,25%,91%)]">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Link to="/" className="flex items-center gap-2 text-[hsl(20,10%,40%)] hover:text-[hsl(20,10%,25%)] mb-8">
          <ArrowLeft className="w-4 h-4" />Volver
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-[hsl(35,20%,88%)] p-8 sm:p-12">
          <h1 className="font-heading font-bold text-3xl text-gray-900 mb-2">Términos y Condiciones</h1>
          <p className="text-sm text-gray-500 mb-8">Última actualización: mayo de 2026</p>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">1. Objeto y aceptación</h2>
            <p className="text-gray-600 leading-relaxed">
              Los presentes Términos y Condiciones regulan el acceso y uso de la plataforma <strong>Partykatu</strong> (en adelante, "el Servicio"), disponible en <a href="https://partykatu.com" className="text-[hsl(144,18%,45%)] hover:underline">partykatu.com</a>, cotitularidad de Alba Pérez Rodríguez (NIF: 72596176B) y Manuel Arroyo González (NIF: 76269479F).
            </p>
            <p className="text-gray-600 leading-relaxed mt-3">
              El acceso y uso del Servicio implica la aceptación plena y sin reservas de estos Términos y Condiciones. Si no estás de acuerdo con alguno de los términos aquí establecidos, debes abstenerte de usar el Servicio.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">2. Descripción del servicio</h2>
            <p className="text-gray-600 leading-relaxed">
              Partykatu es una plataforma digital de búsqueda de compañeros/as de piso que permite a los usuarios crear un perfil personal, explorar perfiles de otros usuarios y establecer contacto con aquellos con quienes exista interés mutuo. El Servicio actúa exclusivamente como intermediario entre usuarios y no es parte en ningún acuerdo de arrendamiento o convivencia que pueda derivarse del uso de la plataforma.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">3. Registro y cuenta de usuario</h2>
            <p className="text-gray-600 leading-relaxed mb-3">Para acceder al Servicio es necesario crear una cuenta. Al registrarte, declaras que:</p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Tienes al menos <strong>18 años de edad</strong>.</li>
              <li>Los datos proporcionados son verídicos, exactos y actualizados.</li>
              <li>Eres el único titular y responsable de tu cuenta.</li>
              <li>Mantendrás la confidencialidad de tu contraseña y notificarás cualquier uso no autorizado a infopartykatu@gmail.com.</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-3">
              Partykatu se reserva el derecho a suspender o eliminar cuentas que incumplan estos Términos, que contengan información falsa o que hayan sido creadas de forma fraudulenta.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">4. Normas de uso</h2>
            <p className="text-gray-600 leading-relaxed mb-3">Al usar Partykatu, te comprometes a no:</p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Publicar información falsa, engañosa o que suplante la identidad de otra persona.</li>
              <li>Acosar, amenazar, insultar o discriminar a otros usuarios por cualquier motivo.</li>
              <li>Publicar contenido obsceno, pornográfico, violento o que vulnere derechos de terceros.</li>
              <li>Usar el Servicio con fines comerciales no autorizados, spam o captación de clientes.</li>
              <li>Intentar acceder de forma no autorizada a sistemas, datos o cuentas de otros usuarios.</li>
              <li>Usar bots, scrapers u otras herramientas automatizadas para acceder o extraer datos del Servicio.</li>
              <li>Realizar cualquier actividad que pueda dañar, sobrecargar o deteriorar el funcionamiento del Servicio.</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-3">
              El incumplimiento de estas normas podrá dar lugar a la suspensión inmediata de la cuenta, sin perjuicio de las acciones legales que pudieran corresponder.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">5. Contenido del usuario</h2>
            <p className="text-gray-600 leading-relaxed">
              El usuario es el único responsable del contenido que publique en Partykatu (fotos, textos, mensajes, etc.). Al publicar contenido, otorgas a Partykatu una licencia no exclusiva, gratuita y mundial para usar, mostrar y distribuir dicho contenido exclusivamente con el fin de prestar el Servicio.
            </p>
            <p className="text-gray-600 leading-relaxed mt-3">
              Partykatu no se responsabiliza del contenido publicado por los usuarios, aunque se reserva el derecho a eliminarlo si infringe estos Términos o la legislación vigente.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">6. Sistema de match e interacciones</h2>
            <p className="text-gray-600 leading-relaxed">
              El Servicio permite a los usuarios mostrar interés en otros usuarios. El intercambio de información de contacto solo se produce cuando existe interés mutuo (match), salvo que el usuario haya activado expresamente la opción de contacto directo. Partykatu no garantiza que el uso del Servicio derive en el encuentro de un compañero/a de piso ni en ningún otro resultado concreto.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">7. Limitación de responsabilidad</h2>
            <p className="text-gray-600 leading-relaxed">
              Partykatu actúa como plataforma de intermediación y no verifica la identidad de los usuarios más allá de la verificación de correo electrónico. No nos responsabilizamos de:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mt-3">
              <li>La veracidad de la información publicada por los usuarios en sus perfiles.</li>
              <li>Las relaciones, acuerdos o conflictos que puedan surgir entre usuarios.</li>
              <li>Las condiciones de los arrendamientos o convivencias que se acuerden fuera de la plataforma.</li>
              <li>Daños derivados de interrupciones del Servicio por causas ajenas a nuestra voluntad.</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-3">
              Recomendamos a los usuarios que extremen las precauciones al compartir información personal y que verifiquen la identidad de las personas con quienes decidan convivir.
            </p>
            <p className="text-gray-600 leading-relaxed mt-3">
              En particular, <strong>Partykatu no es parte, intermediario ni garante de ningún contrato de arrendamiento, subarrendamiento o acuerdo de convivencia</strong> que los usuarios puedan celebrar entre sí como resultado del uso de la plataforma. Cualquier acuerdo de convivencia que se alcance es exclusivamente entre los usuarios implicados, bajo su propia responsabilidad y sin intervención de Partykatu. Se recomienda a los usuarios que formalicen por escrito cualquier acuerdo de convivencia y que verifiquen la identidad de las personas con quienes decidan compartir domicilio antes de firmar cualquier contrato.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">8. Propiedad intelectual</h2>
            <p className="text-gray-600 leading-relaxed">
              Todos los elementos de la plataforma Partykatu (diseño, código, logotipos, textos, imágenes propias) son propiedad de Alba Pérez Rodríguez y Manuel Arroyo González, o de sus licenciantes, y están protegidos por la legislación española e internacional de propiedad intelectual. Queda prohibida su reproducción, distribución o modificación sin autorización expresa.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">9. Modificación y suspensión del servicio</h2>
            <p className="text-gray-600 leading-relaxed">
              Partykatu se reserva el derecho a modificar, suspender o interrumpir el Servicio en cualquier momento, con o sin previo aviso, sin que ello genere responsabilidad alguna. En caso de cambios sustanciales en estos Términos, notificaremos a los usuarios con un mínimo de 15 días de antelación mediante aviso en la plataforma o por correo electrónico.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">10. Baja y eliminación de cuenta</h2>
            <p className="text-gray-600 leading-relaxed">
              El usuario puede eliminar su cuenta en cualquier momento desde la sección "Mi perfil" dentro de la aplicación. La eliminación de la cuenta conllevará la supresión de todos los datos personales asociados en un plazo máximo de 30 días, conforme a lo establecido en nuestra <Link to="/privacidad" className="text-[hsl(144,18%,45%)] hover:underline">Política de Privacidad</Link>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">11. Ley aplicable y jurisdicción</h2>
            <p className="text-gray-600 leading-relaxed">
              Estos Términos y Condiciones se rigen por la legislación española. Para la resolución de cualquier controversia derivada del uso del Servicio, las partes se someten, con renuncia expresa a cualquier otro fuero, a los Juzgados y Tribunales españoles competentes, sin perjuicio de los derechos que asisten a los consumidores conforme a la normativa europea de protección al consumidor.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">12. Contacto</h2>
            <p className="text-gray-600 leading-relaxed">
              Para cualquier consulta sobre estos Términos y Condiciones, puedes contactarnos en:
            </p>
            <div className="mt-3 p-4 bg-[hsl(35,25%,95%)] rounded-xl text-gray-600">
              <p><strong>Email:</strong> <a href="mailto:infopartykatu@gmail.com" className="text-[hsl(144,18%,45%)] hover:underline">infopartykatu@gmail.com</a></p>
              <p className="mt-1"><strong>Web:</strong> <a href="https://partykatu.com" className="text-[hsl(144,18%,45%)] hover:underline">partykatu.com</a></p>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
